import { waitForMs } from '../../../helpers';

export default () => {
  $('#inhouse-form-submit').on('click', function (e) {
    e.preventDefault();
    $('#form-waiting').addClass('active');
    let modal = $('#requestDateModal');

    let event_id = null;
    if (modal.attr('data-event-id')) {
      event_id = modal.attr('data-event-id');
      $('#InhouseContactForm select[name=contact_teamsize]').hide();
    }

    let module_id = null;
    if (modal.attr('data-module-id')) {
      module_id = modal.attr('data-module-id');
    }

    $.ajax({
      url: '/ui/Newsletter@RequestDatePost',
      type: 'post',
      data: {
        form_url: window.location.href,
        form_type: modal.attr('data-form-type'),
        module_id: module_id,
        event_id: event_id,
        contact_name: $('#InhouseContactForm input[name=contact_name]').val(),
        contact_email: $('#InhouseContactForm input[name=contact_email]').val(),
        contact_company: $(
          '#InhouseContactForm input[name=contact_company]'
        ).val(),
        contact_teamsize: $(
          '#InhouseContactForm select[name=contact_teamsize]'
        ).val(),
        contact_message: $(
          '#InhouseContactForm textarea[name=contact_message]'
        ).val(),
      },
      success: function (data) {
        $('#form-waiting').removeClass('active');
        // console.log(data);
        let response = JSON.parse(data);
        // console.log(response);
        if (response['status'] === false) {
          if (response['errors']['name']) {
            $('#InhouseContactForm #validationServerNameFeedBack').text(
              response['errors']['name']
            );
            $('#InhouseContactForm input[name=contact_name]').addClass(
              'is-invalid'
            );
          } else {
            $('#InhouseContactForm input[name=contact_name]').removeClass(
              'is-invalid'
            );
          }

          if (response['errors']['email']) {
            $('#InhouseContactForm #validationServerEmailFeedBack').text(
              response['errors']['email']
            );
            $('#InhouseContactForm input[name=contact_email]').addClass(
              'is-invalid'
            );
          } else {
            $('#InhouseContactForm input[name=contact_email]').removeClass(
              'is-invalid'
            );
          }

          if (response['errors']['textarea']) {
            $('#InhouseContactForm #validationServerMessageFeedBack').text(
              response['errors']['textarea']
            );
            $('#InhouseContactForm textarea[name=contact_message]').addClass(
              'is-invalid'
            );
          } else {
            $('#InhouseContactForm textarea[name=contact_message]').removeClass(
              'is-invalid'
            );
          }
        } else {
          // modal.modal('hide');
          // $('#successful-modal').modal('show');

          onSuccess();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(JSON.stringify(jqXHR));
      },
    });
  });
};

const onSuccess = async () => {
  const inhouseModal = $('.inhouse-training-modal-dialog');

  inhouseModal.css('transform', 'translate(0, -50px)');
  await waitForMs(300);
  inhouseModal.hide();
  await waitForMs(10);
  $('.inhouse-training-success-modal').addClass('show');
  await waitForMs(1500);
  $('.inhouse-training-success-modal').removeClass('show');

  console.log('success');

  await waitForMs(300);
  $('.inhouse-training-modal').removeClass('show').hide();
};
